export class ChecklistFilter {
  date: string;
  created: string;
  name: string;
  comment: string;
  status: number;
  userId: string;
}
